"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Item = void 0;
var _encoreFoundation = require("@spotify-internal/encore-foundation");
var _index = require("../../styles/index.js");
var _index2 = require("../TypeListItem/index.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var Item = exports.Item = (0, _styledComponents["default"])(_index2.TypeListItem).attrs({
  semanticColor: 'textBase',
  condensed: true,
  listStyleReset: true
}).withConfig({
  displayName: "Item",
  componentId: "sc-16ne99o-0"
})(["min-inline-size:0;@media (max-width:", "){padding-block:", ";&:last-child{padding-block-end:0;}}@media (min-width:", "){padding-inline-end:", ";&:last-child{flex-grow:1;padding-inline-end:0;}}"], _encoreFoundation.screenXsMax, (0, _index.cssSpacing)('tighter-4', '4px'), _encoreFoundation.screenSmMin, (0, _index.cssSpacing)('looser-3', '48px'));
var _default = exports["default"] = Item;